import { render, staticRenderFns } from "./AccelerateButton.vue?vue&type=template&id=0914ba8c&scoped=true&"
import script from "./AccelerateButton.vue?vue&type=script&lang=js&"
export * from "./AccelerateButton.vue?vue&type=script&lang=js&"
import style0 from "./AccelerateButton.vue?vue&type=style&index=0&id=0914ba8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914ba8c",
  null
  
)

component.options.__file = "AccelerateButton.vue"
export default component.exports